import React from 'react';
import { useParams } from 'react-router-dom';

//Components
import MovementStockDetail from './Main';

//Hooks
import MovementProvider from '../../../hooks/movements/MovementProvider';

const MovementStockView = () => {
    const { movementId } = useParams();

    return (
        <MovementProvider>
            <MovementStockDetail movementId={movementId} />
        </MovementProvider>
    );
}

export default MovementStockView;